<template>
<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="#000" d="M22.5 12a10.5 10.5 0 1 0-21 0 10.5 10.5 0 0 0 21 0M3 12a9 9 0 1 1 18 0 9 9 0 0 1-18 0m9-3a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m0 4.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3m0 4.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3"/></svg>
</template>
